import Nav from "../Nav";
import Head from "../Head";

const Proyecto = () => {
  window.scrollTo(0, 0);

  return (
    <>
      <Head title="Nosotras - Proyecto" />
      <Nav titulo="Proyecto" link="/nosotras" />
      <section
        id="about_me"
        className="animate__fadeInDown wow animate__animated animate__delay-0s animate__slower"
      >
        <div className="container-fluid overflow-hidden">
          <div className="row marMob">
            <div className="col-12 col-lg-7 fondoImg text-md-start col-xl-9">
              <h3>
                <i className="bi bi-camera-fill"></i>
                <i className="bi bi-tree-fill"></i>
              </h3>
              <hr />
              <h2>Proyecto</h2>
              <p>
                Investigamos y experimentamos con revelados a base de plantas
                reemplazando los tradicionales reveladores y fijadores
                industriales para fotografía blanco y negro. Con ellos revelamos
                tanto películas fotográficas como papeles fotosensibles. Esto
                nos ha permitido relacionarnos de otra manera con el territorio
                y también abrirnos a las posibilidades que el entorno nos brinda
                adquiriendo autonomía en nuestros procesos.
              </p>
              <h2>Antecedentes</h2>
              <p>
                En 2026 participamos como talleristas en las Jornadas
                Chubutenses de Arte y Ciencia en Puerto Madryn y fuimos
                convocadas desde el Festival de Fotografía Analógica Saywa, en
                Perú, para dar una conferencia. También brindamos un taller en
                la Fundación ICBC, en Buenos Aires.
              </p>
              <p>
                En 2024 nos seleccionaron para exponer en la Mini Galería del
                Centro de Expresiones Contemporáneas de Rosario y participamos
                de la muestra colectiva del Festival Internacional Chillán
                Análogo, Chile.
              </p>
              <p>
                En 2023 fuimos convocadas para el Festival “Alma Delta” por la
                Fundación Cause ecológico en Paraná.{" "}
              </p>
              <p>
                Con el proyecto “Jacinto de agua común” recibimos el apoyo del
                Ministerio de Cultura de Santa Fe a través de la Convocatoria
                Plan Fomento 2022 para la publicación de un fotolibro. Con el
                proyecto de residencia “Ir al río” fuimos ganadoras de la Beca
                Formadores del Fondo Nacional de las Artes 2022. Además ese
                mismo año fuimos seleccionadas para la residencia Mudar en Cabo
                Polonio, Uruguay. Y también fuimos invitadas a mostrar en el
                Museo de Ciencias Naturales Angel Gallardo y en el Cine Lumiere,
                ambos en Rosario. Nuestro trabajo ha sido publicado en
                Iberoromanía (De Gruyter), Signatura (Plataforma Latinoamericana
                de Humanidades Ambientales) y diferentes diarios de Argentina.
              </p>
            </div>
            <div className="mb-3 col-12 col-lg-5 col-xl-3 text-center">
              <img
                src="../img/proyecto_1.jpg"
                className="img-fluid "
                alt="Plantas sobre fondo blanco y dos manos ordenandolas"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Proyecto;
